module.exports = __webpack_public_path__ + "img/color_platinum_a-2130-1.6426fa4.webp";